import { UseMutationOptions, useMutation, useQueryClient } from "@tanstack/react-query";
import axiosAuth from "../../axiosAuth";
import { CURRICULUM_MASTER } from "../apiRoutes";

const mutateToggleCurriculumMaster = async ({ id }: { id: string | number }) => {
	return await axiosAuth.patch(`${CURRICULUM_MASTER}${id}`);
};

const useToogleCurriculumMasterMutation = (
	queryParams?: UseMutationOptions<
		any,
		Error,
		{
			id: string | number;
		},
		unknown
	>
) => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: mutateToggleCurriculumMaster,
		onSuccess: (data, variables, context) => {
			queryClient.invalidateQueries({ queryKey: ["curriculumMaster"], exact: false });
			queryParams?.onSuccess?.(data, variables, context);
		},
		...queryParams,
	});
};

export default useToogleCurriculumMasterMutation;
